import React, { useState } from 'react'
import { AutoComplete, AutoCompleteProps, Input } from 'antd'
import { Show } from '../common/Show'
import { getNumbers, hasLetters } from '../common/Utils'
import { ReactComponent as VolanteSVG } from '../../assets/icons/volante-icone.svg'
import { TextFieldInput } from '../common/TextField'
import styled from '@emotion/styled'
type TCotista = {
  id: number
  cpf: string
  nome: string
}

export const CotistasAutocomplete = ({
  onChange,
  onSelect,
  filterOption,
  showDescription = false,
  label,
  prefix,
  name,
  cotistas,
  underAutoComplete,
  ...props
}: {
  onChange?: (value?: any, option?: any) => any
  onSelect?: (value?: any, option?: any) => any
  filterOption?: (value: any, option: any) => any
  prefix?: any
  showDescription?: boolean
  cotistas?: any
  label?: string
  name?: string
  underAutoComplete?: boolean
} & AutoCompleteProps) => {
  const [searchValue, setSearchValue] = useState<any>(null)
  const [cpf, setCpf] = useState(null) as any
  const [selectedCotista, setSelectedCotista] = useState<TCotista | null>(null)

  const handleClick = (e: any) => {
    e?.target?.select?.()
  }

  const handleChangeCotista = (value: any, option: any) => {
    value = value ?? ''
    setSelectedCotista(null)
    //setSearchValue(value)

    setSearchValue(`***${option?.cotistaCpf?.substring(3, 12)}**` || null)
    if (!option?.cotistaCpf) setSearchValue('')

    setCpf(null)

    if (!hasLetters(value)) {
      const localCpf = getNumbers(value)
      if (localCpf?.length === 11) setCpf(localCpf)
    }
    onChange?.(value.toUpperCase())
  }

  const handleSelectCotista = (value: any, option: any) => {
    setSelectedCotista({
      id: option.cotistaId,
      nome: option.cotistaNome,
      cpf: option.cotistaCpf,
    })
    onSelect?.(value, { ...option })
  }

  return (
    <Container>
      <AutoComplete
        style={{ width: '100%' }}
        size="large"
        listHeight={300}
        data-cy="cotista"
        allowClear
        value={searchValue || ''}
        onClick={handleClick}
        onChange={handleChangeCotista}
        onSelect={handleSelectCotista}
        dataSource={cotistas?.map((c: TCotista) => Cotista({ key: c.id, cotista: c }))}
        {...props}
      >
        <TextFieldInput
          label="Instrutor"
          size="large"
          style={{ borderRadius: '5px' }}
          prefix={
            selectedCotista ? (
              <>
                <VolanteSVG /> &nbsp; <strong> {selectedCotista?.nome}&nbsp;- </strong>
              </>
            ) : null
          }
          underAutoComplete={underAutoComplete}
        />
      </AutoComplete>
    </Container>
  )
}
const Container = styled.div`
  > div {
    width: 100%;
    .ant-input-affix-wrapper {
      padding: 0 11px !important;
    }
  }
`

const Cotista = ({ key, cotista }: { key: any; cotista: TCotista }) => {
  return (
    <AutoComplete.Option
      key={key}
      value={cotista.nome}
      cotistaId={cotista.id}
      cotistaCpf={cotista.cpf}
      cotistaNome={cotista.nome}
    >
      <strong>{cotista.nome.toUpperCase()}</strong>
      <br />
      {`***${cotista?.cpf.substring(3, 12)}**`}
      <br />
    </AutoComplete.Option>
  )
}
